import React from "react";

import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import {
  MdmObjectDto,
  useCreateObjectMutation
} from "gql/generated/types";
import { useNavigate, useParams } from "react-router-dom";
import ObjectForm from "../components/ObjectForm";

const NewObjectForm = () => {
  const navigate = useNavigate();
  const { projectId } = useParams();
  const [mutateFunction] = useCreateObjectMutation({
    onCompleted: () => {
      easasAlert({
        severity: "success",
        summary: "Success",
        detail: "Object updated successfully",
        life: 3000,
      });
      navigate(`/${projectId}/`);
    },
    onError: err => {
      easasAlert({ severity: "error", summary: "Error", detail: err.message, life: 3000 });
    },
    refetchQueries: ["GetObjectsByProject"],
  });
 
  
  const handleCreate = (object: MdmObjectDto) => {
    mutateFunction({
      variables: { object: { ...object, projectId } },
    });
  };
  return <ObjectForm object={null} onSubmit={handleCreate} />;
};

export default NewObjectForm;
